import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📦 Components`}</h2>
    <ul>
      <li parentName="ul">{`We’ve kicked off work to build the FAB components for web, iOS, and Android. Zhaotong P., Eric S. and Patrick A. will be building it for their respective platforms.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`ToggleChip`}</inlineCode>{` and `}<inlineCode parentName="li">{`FilterChip`}</inlineCode>{` components have shipped on iOS. (Emily F.)`}</li>
      <li parentName="ul">{`We’ve shipped the `}<inlineCode parentName="li">{`AlertBanner`}</inlineCode>{` component on web, iOS, and Android. Thanks to Lee A., Mallika P., and Brian L. for building.`}</li>
    </ul>
    <h2>{`🍭 Design`}</h2>
    <ul>
      <li parentName="ul">{`Buttons and their related components were updated in Figma to remove manually control padding, saving designers time.`}</li>
      <li parentName="ul">{`A new public, birds-eye view of Thumbprint is now available in Figma. This will be featured on Figma’s `}<a parentName="li" {...{
          "href": "https://designsystems.com"
        }}>{`designsystems.com`}</a>{` site.`}</li>
      <li parentName="ul">{`Jon K. and Lucas S. are both presenting at Config, the Figma conference in SF on Feb 6th.`}</li>
    </ul>
    <h2>{`💰 Tokens`}</h2>
    <ul>
      <li parentName="ul">{`This week we’ll be prototyping component-level design tokens (`}<inlineCode parentName="li">{`button-theme-primary-color-hover`}</inlineCode>{`, for example). These tokens will be layered on top of our existing tokens.`}</li>
    </ul>
    <h2>{`✉️ Email`}</h2>
    <ul>
      <li parentName="ul">{`We held the Thumbprint for Emails kickoff meeting on Jan 28th to start the Design phase of this effort. Jon K. will be working with a cross-functional design team to deliver email assets in Figma.`}</li>
      <li parentName="ul">{`On the developer side we’ll be creating, documenting, and maintaining the components needed to build the emails.`}</li>
    </ul>
    <h2>{`📖 Documentation and Analytics`}</h2>
    <ul>
      <li parentName="ul">{`There’s now a “Was this page helpful?” button at the bottom of documentation pages on `}<a parentName="li" {...{
          "href": "https://thumbprint.design/"
        }}>{`thumbprint.design`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://thumbprint.design/components/chip/android/"
        }}>{`Chip for Android`}</a>{` and `}<a parentName="li" {...{
          "href": "https://thumbprint.design/components/toast/android/"
        }}>{`Toast for Android`}</a>{` are now documented. (Emily F. and Mallika P.)`}</li>
      <li parentName="ul">{`We’ve kicked off work on a component adoption tracking dashboard. This will allow us to understand the impact of individual components all three platforms. (Daniel O., Mallika P., Kevin G.)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      